/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} World_Switcher_LabelInputs */

const en_world_switcher_label = /** @type {(inputs: World_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`World`)
};

const fr_world_switcher_label = /** @type {(inputs: World_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`World`)
};

const ms_sg2_world_switcher_label = /** @type {(inputs: World_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunia`)
};

/**
* | output |
* | --- |
* | "World" |
*
* @param {World_Switcher_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const world_switcher_label = /** @type {((inputs?: World_Switcher_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<World_Switcher_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_world_switcher_label(inputs)
	if (locale === "fr") return fr_world_switcher_label(inputs)
	return ms_sg2_world_switcher_label(inputs)
});